export default "__VITE_PUBLIC_ASSET__e9e2232a__"